import useModals from '@/composables/modals.js'
import { useClientStore } from '@shared/stores/client.js'
import { useNow } from '@vueuse/core'
import { defineStore, storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

export const useUnlimitedTrialStore = defineStore('unlimitedTrial', () => {
  const now = useNow({ interval: 60 * 1000 })
  const clientStore = useClientStore()
  const {
    active,
    membershipDetails,
    plans,
    showUnlimitedSwapsUpgrade,
    selectedPackages,
    subscriptionStartDate,
  } = storeToRefs(clientStore)
  const { updateClient } = clientStore
  const { closeUnlimitedTrialModal } = useModals()

  const bannerDismissed = ref(false)
  const modalDismissed = ref(false)

  const unlimitedTrialEndDate = computed(() => {
    const end = membershipDetails.value?.allowedShipmentsOverridePeriodEnd
    return end ? new Date(end) : null
  })
  const unlimitedTrialActive = computed(() =>
    active.value &&
    (plans.value?.currentBasePlan?.shipmentsPerInterval ?? null) !== null &&
    membershipDetails.value?.allowedShipments === null &&
    !!unlimitedTrialEndDate.value &&
    now.value < unlimitedTrialEndDate.value)
  const showUnlimitedTrialBanner = computed(() =>
    !bannerDismissed.value &&
    unlimitedTrialActive.value &&
    selectedPackages.value > 0)
  const showUnlimitedTrialModal = computed(() => {
    const triggerDate = new Date(subscriptionStartDate.value)
    triggerDate.setDate(triggerDate.getDate() + 23)
    return !modalDismissed.value &&
      showUnlimitedSwapsUpgrade.value &&
      unlimitedTrialActive.value &&
      !!subscriptionStartDate.value &&
      now.value >= triggerDate
  })

  function unlimitedTrialBannerDismissed () {
    bannerDismissed.value = true
  }

  function dismissUnlimitedTrialModal () {
    modalDismissed.value = true
    closeUnlimitedTrialModal()
  }

  async function declineUnlimitedTrialUpgrade () {
    dismissUnlimitedTrialModal()
    showUnlimitedSwapsUpgrade.value = false
    await updateClient({ showUnlimitedSwapsUpgrade: false })
  }

  return {
    bannerDismissed,
    modalDismissed,
    unlimitedTrialEndDate,
    unlimitedTrialActive,
    showUnlimitedTrialBanner,
    showUnlimitedTrialModal,
    unlimitedTrialBannerDismissed,
    dismissUnlimitedTrialModal,
    declineUnlimitedTrialUpgrade,
  }
})
